/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mLoginRewards.vue?vue&type=template&id=2555173b&scoped=true"
import script from "./mLoginRewards.vue?vue&type=script&lang=js"
export * from "./mLoginRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555173b",
  null
  
)

export default component.exports